import React from 'react'
import { Outlet } from 'react-router-dom'

function MainSupplier() {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default MainSupplier
